/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkProjectOtherDTO
 */
export interface WorkProjectOtherDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkProjectOtherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkProjectOtherDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkProjectOtherDTO
     */
    role?: string;
}

/**
 * Check if a given object implements the WorkProjectOtherDTO interface.
 */
export function instanceOfWorkProjectOtherDTO(value: object): value is WorkProjectOtherDTO {
    return true;
}

export function WorkProjectOtherDTOFromJSON(json: any): WorkProjectOtherDTO {
    return WorkProjectOtherDTOFromJSONTyped(json, false);
}

export function WorkProjectOtherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkProjectOtherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'name': json['name'] == null ? undefined : json['name'],
                  'role': json['role'] == null ? undefined : json['role'],
    };
}

export function WorkProjectOtherDTOToJSON(json: any): WorkProjectOtherDTO {
    return WorkProjectOtherDTOToJSONTyped(json, false);
}

export function WorkProjectOtherDTOToJSONTyped(value?: WorkProjectOtherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'role': value['role'],
    };
}


